import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../reports/ReportElementHelper";

class AssessmentDetail extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    if (this.props.node !== undefined) {
      const recs = [];
      getAllRows(
        this.props.node,
        recs,
        this.props,
        _.get(this.props.node, "$.display")
      );
      if (recs.length > 0) {
        rows.push(
          <Table.Row key={`assessment_row`} className="table-no-border">
            <Table.Cell>
              <Table>
                <Table.Body>{recs}</Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        );
      }
    }

    return (
      <Table key={`row_assessment_info_${this.props.internalId}`}>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.HeaderCell>Assessment Information</Table.HeaderCell>
          </Table.Row>
          {rows}
        </Table.Body>
      </Table>
    );
  }
}

export default AssessmentDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/AssessmentDetail.js